// extracted by mini-css-extract-plugin
export var svg = "MenuText-module--svg--0f329";
export var wrap = "MenuText-module--wrap--0f456";